import { Member } from '../Models/Member';
import { SubscriptionLevelNames } from '../Models/Subscription';
import { UserLevelNames } from '../Models/UserLevel';
import { User } from '../Models/User';

export function getMemberSubscriptionId(
  member: Member | null | undefined
): number | null {
  if (!member) {
    return null;
  }

  return member.subscriptionId ?? member.subscription?.id ?? null;
}

export function isPartnerOpportunityNotifyMember(
  member: Member | null | undefined
): boolean {
  const subscriptionId = getMemberSubscriptionId(member);
  return (
    subscriptionId === SubscriptionLevelNames.DistributorMember ||
    subscriptionId === SubscriptionLevelNames.RepMember
  );
}

export function canManagePartnerOpportunityConfiguration(
  user: User | null | undefined,
  memberId: number
): boolean {
  if (!user) {
    return false;
  }

  return (
    user.userLevelId === UserLevelNames.SuperAdmin ||
    user.memberId === memberId
  );
}
